// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1hHek","buttons":"PendingPaymentAlert_buttons__3LNqZ"};